// extracted by mini-css-extract-plugin
export default {"contentContainer":"landing_contentContainer__+lG+d","pageTitle":"landing_pageTitle__QfrpJ","articleIntro":"landing_articleIntro__P6a4h"};